/**
 * @file automatically generated from MApp.Spatial.Ogc.UomType
 */

export enum UomType {
    Pixel = 0,
    Metre = 1,
    Foot = 2
}
/**
 * @file automatically generated from MApp.Spatial.Ogc.VersionType
 */

export enum VersionType {
    Version_1_1_0 = 0
}
